export const PDP_RESTRICTION_URL_PARAM = "packageRestriction";
